/**
 * Small, safe-area aware banner announcing a waiting service worker update.
 */

export type PwaUpdateBannerProps = {
  available: boolean;
  onApply: () => void;
  lang?: string;
};

export function PwaUpdateBanner({ available, onApply, lang }: PwaUpdateBannerProps) {
  if (!available) return null;

  const isHr = lang !== "en";
  const message = isHr ? "Dostupna je nova inačica." : "A new version is available.";
  const action = isHr ? "Osvježi" : "Refresh";

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-0 z-[60] flex flex-wrap items-center justify-center gap-3 bg-primary px-4 text-primary-foreground shadow-md"
      style={{
        paddingTop: "calc(0.5rem + env(safe-area-inset-top))",
        paddingBottom: "0.5rem",
        paddingLeft: "calc(1rem + env(safe-area-inset-left))",
        paddingRight: "calc(1rem + env(safe-area-inset-right))",
      }}
    >
      <span className="text-sm">{message}</span>
      <button
        type="button"
        data-testid="pwa-update-apply"
        onClick={onApply}
        className="min-h-11 rounded-md border border-primary-foreground/40 px-4 text-sm font-semibold"
      >
        {action}
      </button>
    </div>
  );
}

export default PwaUpdateBanner;
